import api from './api';
import { ProductRatingResponse } from '../types/productRating';

export const getProductRatings = async (params?: {
    page?: number;
    limit?: number;
}): Promise<ProductRatingResponse> => {
    const response = await api.get('/product-ratings', { params });
    return response.data;
};

export const deleteProductRating = async (id: string): Promise<{ success: boolean; message: string }> => {
    const response = await api.delete(`/product-ratings/${id}`);
    return response.data;
};
